import React from 'react';
import { motion } from 'framer-motion';
import { Gift, FileText, CheckCircle } from 'lucide-react';
import { SectionHeading } from './Shared';
const bonuses = [{
  title: 'Protocolo de Psicoeducación sobre el Sueño',
  desc: 'Documento descargable listo para sesión o paciente.',
  bullets: ['qué es el sueño y para qué sirve;', 'qué es el insomnio y cómo se desarrolla;', 'círculo vicioso del insomnio;', 'mitos y verdades sobre el sueño;'],
  footer: 'Para que el paciente comprenda su problema y participe mejor del proceso terapéutico.'
}, {
  title: 'Diario de Sueño del Paciente',
  desc: 'Planilla editable para entregar desde la primera sesión.',
  bullets: ['hora de acostarse y de levantarse;', 'despertares nocturnos;', 'calidad subjetiva del sueño;', 'pensamientos nocturnos y observaciones.'],
  footer: 'Para monitorear el patrón de sueño sin registros largos ni difíciles.'
}, {
  title: 'Guía de Higiene del Sueño',
  desc: 'Documento descargable listo para entregar al paciente.',
  bullets: ['rutina previa al sueño;', 'ambiente de descanso;', 'manejo de pensamientos nocturnos;', 'checklist diario de higiene del sueño.'],
  footer: 'Una guía simple, clara y aplicable desde el primer día.'
}];
export function Bonuses() {
  return <section className="py-24 bg-[#fdfbf6]" data-id="element-26">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-4xl mx-auto mb-16" data-id="element-28">
          <div className="inline-flex items-center justify-center gap-2 px-6 py-2 rounded-full bg-green-100 text-green-800 font-bold text-sm md:text-base mb-6 uppercase tracking-wider" data-id="element-29">
            <Gift className="w-5 h-5" data-id="element-30" />
            ¡GRATIS POR EL DÍA DE HOY!
          </div>
          <SectionHeading className="mb-4" data-id="element-31">
            OFERTA ESPECIAL: BONUS PROFESIONALES INCLUIDOS CON TU COMPRA
          </SectionHeading>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8" data-id="element-32">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white rounded-3xl p-8 shadow-lg border-2 border-gold/20 relative flex flex-col h-full" data-id="element-33">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-white px-4 py-1 rounded-full text-sm font-bold shadow-md whitespace-nowrap" data-id="element-34">
                ¡Incluido hoy!
              </div>

              <div className="text-center mb-6 pt-4" data-id="element-35">
                <div className="w-14 h-14 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-36">
                  <FileText className="w-7 h-7 text-gold" data-id="element-37" />
                </div>
                <div className="text-xs font-bold text-gold mb-2 uppercase tracking-wide" data-id="element-38">
                  BONUS #{index + 1}
                </div>
                <h3 className="font-serif text-lg font-bold text-navy leading-snug" data-id="element-39">
                  {bonus.title}
                </h3>
              </div>

              <p className="text-slate-600 text-sm font-medium mb-5 text-center pb-5 border-b border-slate-100" data-id="element-40">
                {bonus.desc}
              </p>

              <div className="flex-grow mb-5" data-id="element-41"></div>

              <div className="bg-slate-50 p-3.5 rounded-xl text-xs text-slate-700 italic border border-slate-100 mt-auto leading-relaxed" data-id="element-42">
                {bonus.footer}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}